export function classNames(
  ...classes: (string | false | null | undefined)[]
): string {
  return classes.filter(Boolean).join(' ')
}

export function capitalize(str: string): string {
  return (str[0] || '').toUpperCase() + str.slice(1)
}
